import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )
  let dateTypeErrorMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.DATE_TYPE_ERROR
  )

  return Yup.object({
    intlcode: Yup.string().required(requiredMessage),
    language: Yup.string().required(requiredMessage),
    indicator: Yup.string().required(requiredMessage),
    subheadingId: Yup.number(),
    descriptionEn: Yup.string(),
    descriptionOth: Yup.string(),
    uomId: Yup.string(),
    hsCategoryId: Yup.string(),
  })
}

export default makeValidationSchema
